class Requirements {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const jobSwiper = document.querySelector('.jobSwiper');
    if(jobSwiper){
      new Swiper(".jobSwiper", {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        spaceBetween: 16,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: true
        },
        breakpoints: {
          768: {
            centeredSlides: false,
            slidesPerView: 1,
            spaceBetween: 40,
          }
        },
        pagination: {
          el: ".js-jobSwiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".js-jobSwiper-next",
          prevEl: ".js-jobSwiper-prev",
        },
      });
    }

    $('.js-acc-search-trigger').click(function(){
      $(this).next().slideToggle();
      $(this).find('.js-acc-search-plus').toggleClass('is-active');
    });

    $('.js-more-btn').click(function(){
      $(this).addClass('is-active');
      $(this).parent('.js-more-content').css('height', 'auto');
      // $(this).toggleClass('is-active');
      // if($(this).hasClass("is-active")) {
      // } else {
      //   $(this).find('.js-more-text').text('続きを見る');
      //   $(this).parent('.js-more-content').css('height', '50rem');
      // }
    });  
  }
}
